import { ca } from '@cian/analytics';

// OK
export const trackGeo = (adAnalyticsCategory, label, formId) => {
  ca('eventSite', {
    name: 'oldevent',
    category: adAnalyticsCategory,
    action: 'GEO',
    label,
    page: {
      pageType: 'AddForm',
      extra: {
        form_id: formId,
      },
    },
  });
};

export const trackHighwayAdd = (highwayId, adAnalyticsCategory, formId) => {
  ca('eventSite', {
    name: 'oldevent',
    category: adAnalyticsCategory,
    action: 'GEO',
    label: ['add_highway', highwayId].join('/'),
    page: {
      pageType: 'AddForm',
      extra: {
        form_id: formId,
      },
    },
  });
};

export const trackUndergroundAdd = (metroId, adAnalyticsCategory, formId) => {
  ca('eventSite', {
    name: 'oldevent',
    category: adAnalyticsCategory,
    action: 'GEO',
    label: ['add_metro', metroId].join('/'),
    page: {
      pageType: 'AddForm',
      extra: {
        form_id: formId,
      },
    },
  });
};

export const trackHighwayDistanceChange = (adAnalyticsCategory, formId) => {
  ca('eventSite', {
    name: 'oldevent',
    category: adAnalyticsCategory,
    action: 'GEO',
    label: 'change_highway_distance',
    page: {
      pageType: 'AddForm',
      extra: {
        form_id: formId,
      },
    },
  });
};

export const trackUndergroundDistanceChange = (adAnalyticsCategory, formId) => {
  ca('eventSite', {
    name: 'oldevent',
    category: adAnalyticsCategory,
    action: 'GEO',
    label: 'change_metro_distance',
    page: {
      pageType: 'AddForm',
      extra: {
        form_id: formId,
      },
    },
  });
};
